import {Typography, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {FRAME_PADDING} from '../constants.js';

const Container = styled(Typography)({
  padding: FRAME_PADDING,
  position: 'absolute',
  top: 0,
  right: 0,
  transformOrigin: 'top right',
  '&:not(:last-child)': {
    right: 'auto',
    left: 0,
    transformOrigin: 'top left',
  },
});

const FrameLabel = props => (
  <Container
    color="inherit"
    variant="h6"
    style={{transform: `scale(${props.scale})`}}
  >
    {props.children}
  </Container>
);

FrameLabel.propTypes = {
  children: PropTypes.node.isRequired,
  scale: PropTypes.number.isRequired,
};

export default FrameLabel;
